<template>
  <!-- App.vue -->
  <v-app>
    <!-- Tutorial Stuff -->
    <!-- overlay_first_step -->
    <v-overlay :z-index="8" :value="overlay_first_step" opacity="0.80">
      <v-container>
        <v-layout align-center class="font">
          <v-col class="text-center overlay_first_step">
            <p>Desde aquí siempre podrás agregar a una mascota</p>
            <p>¡Empecemos agregando a una!</p>
          </v-col>
        </v-layout>
      </v-container>
    </v-overlay>
    <!-- overlay_first_step -->
    <!-- overlay_second_step -->
    <v-overlay
      :z-index="8"
      :value="overlay_second_step"
      opacity="0.80"
      class="font"
    >
      <v-container>
        <v-layout align-center>
          <v-col class="text-center overlay_second_step">
            <p>¡Enlaza a tu mascota con su collar!</p>
          </v-col>
        </v-layout>
      </v-container>
    </v-overlay>
    <!--end overlay_second_step -->
    <!-- overlay_third_step -->
    <v-overlay
      class="font"
      :z-index="8"
      :value="overlay_third_step"
      opacity="0.80"
    >
      <v-col class="text-center overlay_third_step">
        <p>Recuerda llenar los datos adicionales</p>
        <p>
          Recomendamos que pongas tu dirección, <br />
          si tu mascota se extravía cerca de tu domicilio, <br />
          es posible que alguien la lleve a tu casa.
        </p>
        <v-col>
          <v-row align="center" justify="center">
            <v-btn
              color="primary"
              rounded
              class="mr-2"
              style="text-transform:none;"
              @click.prevent="closeOverlay()"
              >Despúes</v-btn
            >
            <v-btn
              color="primary"
              style="text-transform:none;"
              rounded
              @click.prevent="ModifyUserData()"
              >Llenar ahora</v-btn
            >
          </v-row>
        </v-col>
      </v-col>
    </v-overlay>
    <div v-if="overlay_third_step" class="three_step">
      <v-list dense>
        <v-list-item @click.prevent="ModifyUserData()">
          <v-list-item-icon>
            <v-icon> mdi-account-box </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Modificar datos de contacto
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>

    <v-img
      v-if="overlay_third_step"
      src="@/assets/img/tutorial/up-arrow.svg"
      class="up_arrow_three"
      alt=""
    />
    <v-img
      v-if="overlay_third_step"
      src="@/assets/img/tutorial/left-arrow.svg"
      class="previous"
      alt=""
    />
    <!-- End overlay_third_step -->
    <!--  End Tutorial Stuff -->
    <v-navigation-drawer
      temporary
      :permanent="overlay_third_step"
      v-model="drawer"
      app
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img
            v-if="user_profile.picture == null"
            src="@/assets/ObiPetsLogo.svg"
          >
          </v-img>

          <v-img v-else :src="user_profile.picture"> </v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            Hola {{ this.$store.state.auth.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item href="https://obipets.myshopify.com/">
          <v-list-item-icon>
            <v-icon> mdi-home </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Ir a inicio
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'addPet' }">
          <v-list-item-icon>
            <v-icon> mdi-paw </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Agregar mascota
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click.prevent="ModifyUserData()">
          <v-list-item-icon>
            <v-icon> mdi-account-box </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Modificar datos de contacto
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list-item-title class="text-center mt-2">
        Mi información
      </v-list-item-title>

      <v-list dense>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >{{ this.$store.state.auth.name }}
              {{ this.$store.state.auth.last_name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              this.$store.state.auth.email
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-cellphone</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              this.$store.state.auth.phone_number
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item
          href="https://obipets.myshopify.com/pages/preguntas-frecuentes"
        >
          <v-list-item-icon>
            <v-icon> mdi-help </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Preguntas Frecuentes
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link v-if="this.$store.state.auth.isObipetsAdmin">
          <v-list-item-icon>
            <v-icon> mdi-view-dashboard </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <router-link :to="{ name: 'adminDash' }"
                >Ir a panel de administración</router-link
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>

      <!--  <template v-slot:append> -->
      <div class="pa-2">
        <v-btn
          color="orange darken-1"
          style="text-transform:none; color:#fff;"
          block
          @click="_logout"
        >
          Cerrar sesión
        </v-btn>
      </div>
      <!--  </template> -->
    </v-navigation-drawer>
    <!-- Sizes your content based upon application components -->
    <v-content class="maindash font">
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <div class="text-center mb-8">
          <v-btn @click.stop="drawer = !drawer" style="text-decoration:none;">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </div>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card
              class="mx-auto mb-5 mypet"
              max-width="344"
              v-for="pet in pets"
              :key="pet.id"
            >
              <v-col cols="12">
                <v-row align="center" justify="center">
                  <v-avatar size="62">
                    <v-img
                      :src="
                        pet.image === null
                          ? 'https://image.flaticon.com/icons/svg/66/66364.svg'
                          : pet.image
                      "
                    ></v-img>
                  </v-avatar>
                  <v-card-title>
                    {{ pet.name }}
                  </v-card-title>
                </v-row>
              </v-col>
              <div style="position:absolute; top:0; right:0;">
                <v-btn icon @click="pet.showInfo = !pet.showInfo">
                  <v-icon>
                    {{ "mdi-information-outline" }}
                  </v-icon>
                </v-btn>
              </div>
              <v-divider></v-divider>
              <v-card-actions>
                <v-col
                  cols="12"
                  justify="center"
                  aling="center"
                  class="text-center"
                >
                  <v-row class="mb-4">
                    <v-btn
                      text
                      @click="pet.showLocation = !pet.showLocation"
                      style="text-transform:none"
                    >
                      Mis ubicaciones
                      <v-icon color="#A7C84B">{{ "mdi-map-marker" }}</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="indigo" icon @click="ModifyPetData(pet.id)">
                      <v-icon left>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-row>
                  <v-col>
                    <v-card-text
                      v-if="!pet.isActive && getid(pet.id) === 'yes'"
                    >
                      Está placa ha sido dada de baja.
                    </v-card-text>

                    <v-btn
                      @click="
                        unsubscribeDialog = true;
                        UnsubscribeId = pet.id;
                      "
                      color="orange darken-1"
                      v-if="pet.isActive"
                      style="text-transform:none;color:#fff;"
                    >
                      Dar de baja esta placa
                    </v-btn>
                  </v-col>
                  <v-divider></v-divider>

                  <div class="mt-5" v-if="getid(pet.id) === 'yes'">
                    <p class="mx-3 my-1">
                      <span class="font-weight-medium green--text darken-4"
                        >Mascota enlazada</span
                      >
                    </p>
                  </div>
                  <div class="mb-4 mt-4" v-else>
                    <!-- Tutorial Stuff -->
                    <div v-if="overlay_second_step && pets[0].id == pet.id">
                      <v-img
                        src="@/assets/img/tutorial/up-arrow.svg"
                        class="up_arrow"
                        alt=""
                      />

                      <v-btn
                        :class="setZindex(overlay_second_step)"
                        style="text-transform:none; color:#fff;"
                        color="#EF5350"
                        @click.prevent="readCode(pet.id)"
                      >
                        Enlazar
                      </v-btn>
                    </div>
                    <!-- Tutorial Stuff -->
                    <v-btn
                      v-else
                      style="text-transform:none; color:#fff;"
                      color="#EF5350"
                      @click.prevent="readCode(pet.id)"
                    >
                      Enlazar
                    </v-btn>
                  </div>
                </v-col>
              </v-card-actions>
              <v-expand-transition>
                <div v-show="pet.showLocation">
                  <v-divider></v-divider>
                  <p class="mx-3 mt-3">
                    <small class="font-weight-medium deep-orange--text">
                      Las ubicaciones son aproximadas, puede tener un margen de
                      hasta 30m de diferencia.
                    </small>
                  </p>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-col cols="12">
                      <v-row
                        align="center"
                        justify="space-around"
                        v-for="location in pet['petLocationHistory']
                          .slice()
                          .reverse()"
                        track-by="id"
                        :key="location.key"
                      >
                        <p>{{ location["createdAt"] }}</p>
                        <v-btn
                          href="#"
                          icon
                          class="mb-5"
                          @click="openMap(location)"
                        >
                          <v-icon color="green lighten-1">
                            {{ "mdi-google-maps" }}
                          </v-icon>
                        </v-btn>
                        <v-btn
                          href="#"
                          icon
                          class="mb-5"
                          v-clipboard:copy="location.getGoogleMapsUri"
                          v-clipboard:success="copyLocation"
                        >
                          <v-icon color="orange darken-1">
                            {{ "mdi-share-variant" }}
                          </v-icon>
                        </v-btn>

                        <v-btn
                          href="#"
                          icon
                          class="mb-5"
                          @click="removeLocation(location.id, pet)"
                        >
                          <v-icon color="red lighten-1">
                            {{ "mdi-delete" }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <div v-if="!pet['petLocationHistory'].length">
                        <p>Nadie ha reportado a tu mascota</p>
                      </div>
                    </v-col>
                  </v-card-text>
                </div>
              </v-expand-transition>
              <v-expand-transition>
                <div v-show="pet.showInfo">
                  <v-divider></v-divider>

                  <v-card-text>
                    <div>
                      <label for="Nombre">Nombre:</label>
                      <p>{{ pet.name }}</p>
                    </div>
                    <div>
                      <label for="Nombre">Especie:</label>
                      <p>{{ pet.species }}</p>
                    </div>
                    <div>
                      <label for="Sexo">Sexo:</label>
                      <p>{{ pet.gender }}</p>
                    </div>
                    <div>
                      <label for="">Fecha de nacimiento:</label>
                      <p>{{ pet.dateBirth }}</p>
                    </div>
                    <div>
                      <label for="">Raza:</label>
                      <p>{{ pet.race }}</p>
                    </div>
                    <div>
                      <label for="">¿Está esterilizado?</label>
                      <p>{{ pet.sterilized }}</p>
                    </div>
                    <div>
                      <label for="">¿Está Vacunado?</label>
                      <p>{{ pet.vaccinated }}</p>
                    </div>
                    <div>
                      <label for="">¿Convive con otros animales?</label>
                      <p>{{ pet.coexistAnimals }}</p>
                    </div>
                    <div>
                      <label for="">¿Cuáles?</label>
                      <p v-if="pet.coexistAnimalsDescription == ''">
                        No hay información
                      </p>
                      <p v-else>{{ pet.coexistAnimalsDescription }}</p>
                    </div>
                    <div>
                      <label for="">¿Convive con niños pequeños?</label>
                      <p>{{ pet.coexistLittleChill }}</p>
                    </div>
                    <div>
                      <label for="">¿Convive con adultos mayores?</label>
                      <p>{{ pet.coexistAncient }}</p>
                    </div>
                    <div>
                      <label for="">¿Padece alguna enfermedad?</label>
                      <p>{{ pet.sickness }}</p>
                    </div>
                    <div>
                      <label for="">¿Cuál?</label>
                      <p v-if="pet.sicknessDescription == ''">
                        No hay información
                      </p>
                      <p v-else>{{ pet.sicknessDescription }}</p>
                    </div>
                    <div>
                      <label for="">¿Tiene alguna alergia?</label>
                      <p>{{ pet.allergies }}</p>
                    </div>
                    <div>
                      <label for="">¿A que?</label>
                      <p v-if="pet.allergiesDescription == ''">
                        No hay información
                      </p>
                      <p v-else>{{ pet.allergiesDescription }}</p>
                    </div>
                    <div>
                      <label for="">Notas:</label>
                      <p>{{ pet.notes }}</p>
                    </div>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
            <div class="text-right">
              <!-- Tutorial Stuff -->
              <v-img
                v-if="overlay_first_step"
                src="@/assets/img/tutorial/right-drawn-arrow.svg"
                class="arrow"
                alt=""
              />
              <!-- Tutorial Stuff -->

              <v-btn
                id="addPetButton"
                :class="setZindex(overlay_first_step)"
                fab
                dark
                color="indigo"
                @click.prevent="goToAddPet"
              >
                <v-icon>mdi-plus</v-icon>
                <v-icon dark>mdi-paw</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-dialog v-model="unsubscribeDialog" persistent max-width="390">
          <v-card class="font background">
            <v-card-text
              ><p style="padding:15px;color:#fff;">
                ¿Seguro quieres dar de baja está placa? <br />
                Al hacerlo ya no podrás darla de alta nuevamente.
              </p></v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="text-transform:none;"
                color="green darken-1"
                text
                @click="unsubscribeDialog = false"
                >Cancelar</v-btn
              >
              <v-btn
                style="text-transform:none;"
                color="green darken-1"
                text
                @click="Unsubscribe"
                >Aceptar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
    <v-snackbar v-model="snackbar">
      {{ snackbarTxt }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>
<script>
import { mapActions } from "vuex";
export default {
  mounted() {
    console.log(this.$store.state.auth.newuser);
    this.getMyPets().then((res) => {
      this.pets = res.results.map((item) => {
        item["showInfo"] = false;
        item["showLocation"] = false;
        this.user_profile = item["owner"].userprofile;
        return item;
      });
      if (this.pets.length == 0) {
        this.overlay_first_step = true;
      } else if (this.$store.state.auth.newuser && this.pets.length >= 1) {
        this.overlay_second_step = true;
        this.$store.state.auth.seconddotone = true;
      }
    });
    this.petCodes().then((res) => {
      this.codes = res.results.map((item) => {
        return item;
      });
    });
  },
  data() {
    return {
      pet: {
        id: null,
      },
      overlay_step: true,
      UnsubscribeId: null,
      unsubscribeDialog: false,
      position: null,
      overlay_first_step: false,
      overlay_third_step: false,
      overlay_second_step: false,
      locations: false,
      id_4_codes_pet: false,
      idUser: "",
      drawer: false,
      show: false,
      codes: [],
      pets: [],
      data_user: [],
      user_profile: [],
      snackbar: false,
      snackbarTxt: "",
      modifyPets: [],
    };
  },

  methods: {
    ...mapActions("auth", { logout: "logout" }),
    ...mapActions("pets", {
      getMyPets: "getMyPets",
      petCodes: "petCodes",
      removeLocationAction: "removeLocationAction",
      Unsuscribe: "Unsuscribe",
    }),
    Unsubscribe() {
      this.unsubscribeDialog = false;
      this.pet.id = this.UnsubscribeId;
      this.Unsuscribe(this.pet).then(() => {
        this.$router.go();
      });
    },
    closeOverlay() {
      this.overlay_third_step = false;
      this.$store.state.auth.newuser = false;
    },
    setZindex(status) {
      if (status) {
        var z = "zindextwo";
        return z;
      } else if (!status) {
        var c = "zindexone";
        return c;
      }
    },
    // eslint-disable-next-line no-unused-vars
    getid(id_pet) {
      let result;
      let linked = false;
      for (let key in this.codes) {
        if (this.codes[key].pet !== null) {
          if (this.codes[key].pet.id === id_pet) {
            linked = true;
          }
        }
      }
      if (linked) {
        result = "yes";
        this.overlay_second_step = false;
        if (this.$store.state.auth.newuser) {
          this.drawer = true;
          this.overlay_third_step = true;
          this.$store.state.auth.seconddotone = false;
        } else {
          this.$store.state.auth.seconddotone = false;
        }
      } else {
        result = "no";
      }
      return result;
    },
    readCode(id_pet) {
      this.$router.push({
        name: "linkpet",
        params: { id_pet },
      });
    },
    ModifyPetData(id) {
      this.$router.push({
        name: "modifyPet",
        params: { id },
      });
    },
    ModifyUserData() {
      let idUser = this.$store.state.auth.id;
      this.$router.push({
        name: "userDetails",
        params: { idUser },
      });
    },
    goToAddPet() {
      this.$router.push({
        name: "addPet",
      });
    },
    openMap(location) {
      if (location.latitude && location.longitude) {
        let url = location["getGoogleMapsUri"];
        window.open(url, "_blank");
      } else {
        this.dialog = true;
      }
    },
    copyLocation() {
      this.snackbar = true;
      this.snackbarTxt = "Ubicación para compartir copiada";
    },
    removeLocation(locationId, pet) {
      this.removeLocationAction(locationId)
        .then(() => {
          this.snackbar = true;
          this.snackbarTxt = "Ubicación eliminada exitosamente";
          this.pets = this.pets.map((petItem) => {
            if (petItem.id === pet.id) {
              petItem.petLocationHistory = petItem.petLocationHistory.filter(
                (location) => {
                  return location.id !== locationId;
                }
              );
            }
            return petItem;
          });
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarTxt = `Ocurrio un error: ${err}`;
        });
    },
    _logout() {
      this.logout();
      this.$router
        .push({
          name: "login",
        })
        .catch(() => {});
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/fontface";
.background {
  background-image: url("../../assets/img/backgrounds/fondoazul.png");
  background-size: cover;
}
.font {
  font-family: "Kaleko", sans-serif;
}
.overlay_third_step {
  margin-top: 0;
  p {
    font-size: 19px;
  }
  @media only screen and (max-width: 1200px) {
    margin-top: 300px;
    p {
      font-size: 16px;
    }
  }
}
.up_arrow_three {
  top: 200px;
  position: absolute;
  z-index: 8;
  right: 28%;
  width: 150px;
  display: block;
  @media only screen and (min-width: 1200px) {
    display: none;
  }
}
.three_step {
  left: 5px;
  margin-top: 135px;
  position: absolute;
  z-index: 8;
  background-color: #fff;
}
.previous {
  top: 50px;
  position: absolute;
  z-index: 8;
  left: 20%;
  height: 240px;
  width: 240px;
  display: block;
  @media only screen and (max-width: 1200px) {
    display: none;
  }
}
.overlay_second_step {
  margin-top: 400px;
  p {
    font-size: 20px;
  }

  @media only screen and (min-width: 1200px) {
    margin-top: 500px;
    p {
      font-size: 28px;
    }
  }
}
.overlay_first_step {
  margin-top: 150px;
}
.zindexone {
  z-index: 0;
}
.zindextwo {
  z-index: 8;
}
#addPetButton {
  margin: 30px;
}
.up_arrow {
  margin-top: 50px;
  position: absolute;
  z-index: 8;
  right: 24%;
  height: 180px;
  width: 180px;
  @media only screen and (min-width: 1200px) {
    margin-top: 50px;
    right: 15%;
    height: 225px;
    width: 225px;
  }
}
.arrow {
  position: absolute;
  margin: 40px 15px 0 0;
  z-index: 8;
  right: 28%;
  height: 180px;
  width: 180px;
  @media only screen and (min-width: 1200px) {
    margin: 40px 0 0 0;
    right: 43%;
    height: 220px;
    width: 220px;
  }
}
.maindash {
  background-image: url("../../assets/img/backgrounds/fondoblanco.png");
  background-size: cover;
}
</style>
